import { Col, Row, Typography } from 'antd'

import CourtBookingsSection from './CourtBookingsSection'
import RegistrationSection from './RegistrationSection'
import WelcomeSection from './WelcomeSection'

const colProps = {
  style: {
    padding: '1em',
  },
}

const { Paragraph, Title } = Typography

const HomePage = () => {
  return (
    <>
      {/* <Row>
        <Col {...colProps} xs={24}>
          <Messages />
        </Col>
      </Row> */}
      {/* <ClubChampionshipsSection /> */}
      <WelcomeSection />
      <Row>
        <Col {...colProps} xs={24}>
          <CourtBookingsSection />
        </Col>
        <Col {...colProps} xs={24}>
          <RegistrationSection />
          {/* <Section title="Registration" level={2}>
            <Paragraph>Online registration and summer camp signups will open on April 1st!</Paragraph>
          </Section> */}
        </Col>
      </Row>

      {/* <Row>
        <Col {...colProps} xs={24} md={24} lg={12} xl={12} xxl={12}>
          <AdultLessonsSection />
        </Col>
        <Col {...colProps} xs={24} md={24} lg={12} xl={12} xxl={12}>
          <DoublesLeagueSection />
        </Col>
        <Col {...colProps} xs={24} md={24} lg={12} xl={12} xxl={12}>
          <LaddersSection />
        </Col>
        <Col {...colProps} xs={24} md={24} lg={12} xl={12} xxl={12}>
          <InterurbanSection />
        </Col>
      </Row> */}
      {/* <Row>
        <Col {...colProps} xs={24}>
          <StringingSection />
        </Col>
      </Row> */}
      {/* <Row>
        <Col {...colProps} xs={24}>
          <Section title="Closed for the season" level={2}>
            <Paragraph>
              The club has closed for the season. Check back in March for information about the upcoming season and how
              to register.
            </Paragraph>
          </Section>
        </Col>
      </Row> */}
    </>
  )
}

export default HomePage
